import React from 'react';
import { Typography, Button } from '@mui/material';
import './main.css';  // Custom CSS file
import img1 from '../assets/img/dash.jpg'; // First hero image
import img2 from '../assets/img/desk.jpg'; // Second hero image
import img3 from '../assets/img/qw.jpg'; // Third hero image

function Hero({darkMode}) {
  const slides = [
    {
      title: "Welcome to Fincal Business Solutions",
      description: "Reliable, accurate, and personalized accounting and tax services for businesses and individuals.",
      buttonText: "Read More",
      background: img1,
    },
    {
      title: "Grow with Us",
      description: "Helping businesses thrive through sound financial solutions and strategies.",
      buttonText: "Discover More",
      background: img2,
    },
    {
      title: "Tailored Financial Solutions",
      description: "Customized services to meet your unique accounting and tax needs.",
      buttonText: "Learn More",
      background: img3,
    },
  ];

  return (
    <section id="hero" className="hero">
      <div id="hero-carousel" className="carousel carousel-fade" data-bs-interval="5000" data-bs-ride="carousel">
        {slides.map((slide, index) => (
          <div
            className={`carousel-item ${index === 0 ? 'active' : ''}`}
            key={index}
            style={{
              backgroundImage: `url(${slide.background})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <div className="carousel-container">
              <Typography variant="h2" className="animate__animated animate__fadeInDown">
                {slide.title}
              </Typography>
              <Typography
                variant="body1"
                className="animate__animated animate__fadeInUp"
                style={{ marginTop: '1rem', fontSize: '1.2rem', maxWidth: '80%' }}
              >
                {slide.description}
              </Typography>
              <Button
                variant="contained"
                className="btn-get-started animate__animated animate__fadeInUp"
                style={{ marginTop: '2rem', padding: '12px 32px', fontSize: '14px' }}
                href="#about"
              >
                {slide.buttonText}
              </Button>
            </div>
          </div>
        ))}

        <a className="carousel-control-prev" href="#hero-carousel" role="button" data-bs-slide="prev">
          <span className="carousel-control-prev-icon bi bi-chevron-left" aria-hidden="true"></span>
        </a>

        <a className="carousel-control-next" href="#hero-carousel" role="button" data-bs-slide="next">
          <span className="carousel-control-next-icon bi bi-chevron-right" aria-hidden="true"></span>
        </a>
      </div>
    </section>
  );
}

export default Hero;
